
const topSpecial = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const secSpecial = document.getElementById('jsSecSpecial');
    const listAreas = secSpecial.querySelectorAll('.js-list-area');


    if (sW > 750) {

    } else {

      listAreas.forEach((element, index) => {

        let tl = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: element,
            // endTrigger: 'body',
            start: "0% 50%",
            end: "100% 50%",
            onEnter: () => element.classList.add('act-sp'),
            onEnterBack: () => element.classList.add('act-sp'),
            onLeave: () => element.classList.remove('act-sp'),
            onLeaveBack: () => element.classList.remove('act-sp'),
            // markers: true,
          },
        })

        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            tl.scrollTrigger.refresh()
          });
        });
        observer.observe(target);

      });

    }



  }
})();
export default topSpecial;